import request from "@/utils/request";

export default function agentDisableCard(params) {
    return request({
        url: `/user/card/agentDisableCard`,
        method: 'post',
        params: params
    })
}
